// Video Popup 
const fabricPlayVideo = document.querySelector('.material-fabric__learn-more');
const videoPopup = document.querySelector('.material-fabric__video-popup');

// Open Popup
fabricPlayVideo.addEventListener('click', function() {
  const videoHTML = `
  <div class="material-fabric__video-container">
    <div class="material-fabric__video">
      <iframe 
        src="https://www.youtube.com/embed/Uwhahq0BUPA" 
        title="YouTube video player" 
        frameborder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowfullscreen>
      </iframe>
    </div>
  </div>`;

  videoPopup.innerHTML = '';
  videoPopup.classList.remove('hidden');
  videoPopup.classList.add('videoIsAdded');
  videoPopup.insertAdjacentHTML('beforeend', videoHTML);
})

// Close popup
const closeVideoPopup = function() {
  videoPopup.classList.add('hidden');
  videoPopup.innerHTML = '';
}

videoPopup.addEventListener('click', closeVideoPopup);
window.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeVideoPopup();
});